import React, { Component, Fragment } from 'react';
import SideContent from './charge-components/SideContent';
import Header from '../../../components/Header';
import ChargeTable from './charge-components/ChargeTable';
import ExtratoResumo from './charge-components/ExtratoResumo';
import ExtratoFaixaConsumoTable from './charge-components/ExtratoFaixaConsumoTable';
import ExtratoDescritivoSection from './charge-components/ExtratoDescritivoSection';
import { ExtratoCard, ExtratoCardTitle } from './charge-components/ExtratoReportStyles';
import { BaseColumn } from '@bit/wavfichacerta.fichacerta.shared-styles.columns';
import { StyledRow } from '@bit/wavfichacerta.fichacerta.shared-styles.rows';
import { bindActionCreators } from 'redux';
import { getChargeData, resetFilters, changeFilters } from './actions';
import { connect } from 'react-redux';
import { Main, MainContainer } from './../../operational/request/resume/RequestResume';
import { BREADCRUMB_FINANCEIRO } from '../../../utils/breadcrumbFinanceiro';
import moment from 'moment';
import Tour from 'reactour';
import axios from 'axios';
import { LoadingContainer, ContainerGifLoading } from '../../../components/shared/table/styled';
import icons from '../../../components/shared/treatedIcons';
import getEnvironment from '../../../utils/getEnvironment';

const { LoadingCircle } = icons;

let API_NODE_V1_URL = process.env.REACT_APP_API_NODE_V1_URL;

const environment = getEnvironment();

if (environment === 'production') {
  API_NODE_V1_URL = process.env.REACT_APP_API_NODE_V1_URL_PROD;
} else if (environment === 'staging') {
  API_NODE_V1_URL = process.env.REACT_APP_API_NODE_V1_URL_STAG;
}

const steps = [
  {
    selector: 'table tr',
    content: 'Confira aqui o consumo por período de utilização da FC ANALISE.',
  },
  {
    selector: '.date-container',
    content: 'Selecione o período desejado',
  },
  {
    selector: '.button-filtrar',
    content: 'Clique em filtrar para obter as informações',
  },
  {
    selector: '.value-container',
    content: 'Aqui você observa o valor consumido no período',
  },
  {
    selector: '.imprimir-pdf',
    content: 'Você pode salvar em PDF',
  },
  {
    selector: '.salvar-excel',
    content:
      'Ou mesmo exportar para o excel, lembrando que o arquivo contém o nome dos usuários que fizeram a solicitação, data e horário da análise. O que facilita caso queira acompanhar o consumo por usuário.',
  },
];

function formatPeriodoLabel(iso) {
  if (!iso) return '';
  const p = String(iso).split(' ')[0].split('-');
  if (p.length !== 3) return '';
  return `${p[2]}/${p[1]}/${p[0]}`;
}

class Charge extends Component {
  state = {
    filtered: false,
    hasFiltred: false,
    didMount: false,
    tourOpen: false,
    tourId: null,
  };

  componentDidMount() {
    const start_date = moment().startOf('month').toISOString();
    const end_date = moment().endOf('day').toISOString();
    this.setState({ didMount: true });
    this.props.changeFilters({ start_date, end_date });
    this.props.getChargeData();
  }

  componentDidUpdate(prevProps) {
    if (this.state.hasFiltred) return;
    const loaded = this.props.resume && Object.keys(this.props.resume).length > 0;
    if (loaded && !this.props.isRequesting) {
      this.setState({ hasFiltred: true, filtered: true });
    }
  }

  componentWillUnmount() {
    this.props.resetFilters();
  }

  getCheckOnboard = async () => {
    try {
      const URL = API_NODE_V1_URL + '/onboard/permission/check';

      const data = {
        email: this.props.login.user.usuario.email,
      };

      let tourOpen = false;
      let hasPage = false;

      const result = await axios.post(URL, data);
      if (result.data.length) {
        result.data.forEach((item) => {
          if (item.pagina === 'home' && item.ver_depois === 0) {
            tourOpen = true;
          }

          if (item.pagina === 'cobranca') {
            hasPage = true;
          }
        });
      }

      if (hasPage === false) {
        this.setState({ tourOpen });
      }
    } catch (err) {
      console.log('ERR:', err);
    }
  };

  postCheckOnboard = async () => {
    try {
      const URL = API_NODE_V1_URL + '/onboard/permission/register';

      const data = {
        email: this.props.login.user.usuario.email,
        verDepois: false,
        page: 'cobranca',
      };

      await axios.post(URL, data);
    } catch (err) {
      console.log('ERR:', err);
    }
  };

  handleTourClose = () => {
    this.setState({ tourOpen: false });
    this.postCheckOnboard();
  };

  postAfterOpenOnboard = async () => {
    try {
      const URL = API_NODE_V1_URL + '/onboard';

      const data = {
        email: this.props.login.user.usuario.email,
        page: 'cobranca',
        name: this.props.login.user.usuario.nome,
        cargo: this.props.login.user.usuario.funcao,
        customer: this.props.login.user.usuario.cliente,
      };

      const result = await axios.post(URL, data);
      this.setState({ tourId: result.data.id });
    } catch (err) {
      console.log('ERR:', err);
    }
  };

  postCurrentStepOnboard = async (curr) => {
    try {
      const URL = API_NODE_V1_URL + '/onboard/steps';
      const step = curr + 1;

      const data = {
        tourId: this.state.tourId,
        step,
      };

      await axios.post(URL, data);
    } catch (err) {
      console.log('ERR:', err);
    }
  };

  handleCallBackSubmitFilter = () => {
    this.setState({ hasFiltred: true, filtered: true });
  };

  renderSideContent() {
    const { filtered } = this.state;
    return <SideContent filtered={filtered} callback={this.handleCallBackSubmitFilter} />;
  }

  renderConteudoPrincipal = () => {
    const { resume, isRequesting, solicitacoes, chargeLoadError } = this.props;
    const { hasFiltred, didMount } = this.state;

    const resumeVazio = !resume || Object.keys(resume).length === 0;

    if (!hasFiltred) {
      if (!didMount || isRequesting) {
        return (
          <LoadingContainer>
            <ContainerGifLoading>
              <LoadingCircle />
            </ContainerGifLoading>
          </LoadingContainer>
        );
      }
      if (chargeLoadError && resumeVazio) {
        return (
          <p style={{ color: '#c62828', fontSize: 13, textAlign: 'center', padding: '20px 12px' }}>
            Não foi possível carregar o relatório. Ajuste o período e clique em <strong>FILTRAR</strong>.
          </p>
        );
      }
      if (resumeVazio) {
        return (
          <p style={{ color: '#78909c', fontSize: 13, textAlign: 'center', padding: '20px 12px' }}>
            Nenhum dado encontrado para o período. Ajuste as datas e clique em <strong>FILTRAR</strong>.
          </p>
        );
      }
    }

    if (isRequesting) {
      return (
        <LoadingContainer>
          <ContainerGifLoading>
            <LoadingCircle />
          </ContainerGifLoading>
        </LoadingContainer>
      );
    }

    if (!resume || !Object.keys(resume).length || !hasFiltred) {
      return (
        <p style={{ color: '#78909c', fontSize: 13, textAlign: 'center', padding: '20px 12px' }}>
          Ajuste o filtro acima e clique em <strong>FILTRAR</strong> para atualizar o relatório.
        </p>
      );
    }

    return (
      <Fragment>
        {!resume.a_vista ? (
          <ExtratoCard>
            <ExtratoResumo resume={resume} />
          </ExtratoCard>
        ) : (
          <ExtratoCard>
            <ExtratoCardTitle style={{ color: '#c62828' }}>Consumo à vista</ExtratoCardTitle>
            <ChargeTable />
          </ExtratoCard>
        )}

        <ExtratoCard>
          <ExtratoCardTitle>Faixa de consumo</ExtratoCardTitle>
          {resume.tabela ? (
            <ExtratoFaixaConsumoTable resume={resume} tabela={resume.tabela} />
          ) : (
            <p style={{ fontSize: 12, color: '#78909c' }}>Tabela de preços indisponível. Atualize a API.</p>
          )}
        </ExtratoCard>

        <ExtratoCard>
          <ExtratoDescritivoSection resume={resume} solicitacoes={solicitacoes} hasFiltered={hasFiltred} />
        </ExtratoCard>
      </Fragment>
    );
  };

  render() {
    const { resume } = this.props;
    const { hasFiltred } = this.state;

    const subtitleNode = (
      <Fragment>
        {hasFiltred && resume && resume.resumo && resume.resumo.periodo ? (
          <span style={{ display: 'block', fontSize: 12, marginTop: 4, color: '#444' }}>
            {formatPeriodoLabel(resume.resumo.periodo.start_date)} - {formatPeriodoLabel(resume.resumo.periodo.end_date)}
          </span>
        ) : null}
      </Fragment>
    );

    return (
      <Main>
        <Header
          breadcrumb={BREADCRUMB_FINANCEIRO}
          title="RELATÓRIO DE CONSUMO"
          actualLink="RELATÓRIO DE CONSUMO"
          subtitle={subtitleNode}
          openTourCallback={(call) => this.setState({ tourOpen: call })}
        />
        <MainContainer>
          <StyledRow justify="flex-start" align="flex-start">
            <BaseColumn xs="12" sm="12" md="12" lg="12" xl="12">
              <ExtratoCard>
                <ExtratoCardTitle style={{ color: '#152b4e', marginBottom: 16 }}>Filtro do período</ExtratoCardTitle>
                {this.renderSideContent()}
              </ExtratoCard>
              {this.renderConteudoPrincipal()}
            </BaseColumn>
          </StyledRow>
        </MainContainer>
        <Tour
          steps={steps}
          isOpen={this.state.tourOpen}
          onRequestClose={this.handleTourClose}
          getCurrentStep={this.postCurrentStepOnboard}
          onAfterOpen={this.postAfterOpenOnboard}
        />
      </Main>
    );
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({ getChargeData, resetFilters, changeFilters }, dispatch);

const mapStateToProps = (state, ownProps) => ({
  ...ownProps,
  resume: state.chargeData.resume,
  isRequesting: state.chargeData.isRequesting,
  chargeLoadError: state.chargeData.error,
  login: state.login,
  solicitacoes: state.chargeData.requests,
});

export default connect(mapStateToProps, mapDispatchToProps)(Charge);
